import { apiService } from './api';

export interface TwoFactorSetupResponse {
  success: boolean;
  secret: string;
  qrCode: string;
  message: string;
}

export interface TwoFactorStatusResponse {
  success: boolean;
  twoFactorEnabled: boolean;
}

export interface TwoFactorVerifyResponse {
  success: boolean;
  message?: string;
  token?: string;
  user?: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    role: string;
  };
}

const twoFactorService = {
  // Get 2FA status for current user
  getStatus: async (): Promise<TwoFactorStatusResponse> => {
    return apiService.get<TwoFactorStatusResponse>('/2fa/status');
  },

  // Setup 2FA - generates secret and QR code
  setup: async (): Promise<TwoFactorSetupResponse> => {
    return apiService.post<TwoFactorSetupResponse>('/2fa/setup', {});
  },

  // Verify setup code and enable 2FA
  verifySetup: async (code: string): Promise<TwoFactorVerifyResponse> => {
    return apiService.post<TwoFactorVerifyResponse>('/2fa/verify-setup', { code });
  },

  // Disable 2FA
  disable: async (code: string): Promise<TwoFactorVerifyResponse> => {
    return apiService.post<TwoFactorVerifyResponse>('/2fa/disable', { code });
  },

  // Verify 2FA code during login
  verifyLogin: async (tempToken: string, code: string): Promise<TwoFactorVerifyResponse> => {
    return apiService.post<TwoFactorVerifyResponse>('/2fa/verify-login', { tempToken, code });
  },

  // Admin: Enable 2FA for a user
  adminEnableForUser: async (userId: string): Promise<TwoFactorSetupResponse> => {
    return apiService.post<TwoFactorSetupResponse>(`/2fa/admin/enable/${userId}`, {});
  },

  // Admin: Disable 2FA for a user
  adminDisableForUser: async (userId: string): Promise<TwoFactorVerifyResponse> => {
    return apiService.post<TwoFactorVerifyResponse>(`/2fa/admin/disable/${userId}`, {});
  },
};

export default twoFactorService;
